/**
 * Contact Information Constants
 * Single source of truth for contact details
 */

export const SITE_URL = 'https://umituz.com'

export const CONTACT_EMAIL = 'umituz9999@gmail.com'

export const CONTACT_INFO = {
  email: CONTACT_EMAIL,
  github: {
    url: 'https://github.com/umituz',
    handle: 'umituz'
  },
  linkedin: {
    url: 'https://www.linkedin.com/in/umitzz/',
    handle: 'umitzz'
  }
} as const
